
import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';

const TrustSection: React.FC = () => {
  return (
    <section className="py-20 bg-emerald-600 text-white relative overflow-hidden">
      <motion.div 
        animate={{ 
          scale: [1, 1.2, 1],
          opacity: [0.1, 0.2, 0.1],
        }}
        transition={{ 
          duration: 8, 
          repeat: Infinity,
          ease: "easeInOut" 
        }}
        className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2 pointer-events-none" 
      />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div 
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" as const }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3 mb-6">
            <ShieldCheck size={32} className="text-emerald-200" />
            <h2 className="text-3xl md:text-4xl font-bold">Privacy & Ethics First</h2>
          </div>
          <div className="space-y-4 text-emerald-100 text-lg leading-relaxed">
            <p>“No personal data will be misused. Survey data is anonymous and used only for research & product improvement.”</p>
            <p>We are committed to building a platform that respects the sanctity of healthcare data. Our research follows strict ethical guidelines to ensure your feedback remains confidential.</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustSection;
